import React, { useContext, useState } from "react";
import { Navbar, Button, Badge } from "react-bootstrap";
import { NavLink } from "react-router";
import Icon from './Icon';
import {
    faWifi as cloudOfflineOutline,
    faCloud as cloudOutline,
    faSync as sync,
    faUser as userIcon,
    faLock as lockIcon,
} from '@fortawesome/free-solid-svg-icons';
import Tabs from "./tabs";
import WheelPropsModal from "./wheelPropsModal";
import { WebSocketContext } from "../websocket/websocket";
import { InstructionModal } from "./instructionModal";
import { UserContext } from "../components/auth/auth";
import { useReadonly } from "../contexts/readonlyContext";
import { useTariffsModal } from "../contexts/tariffsModalContext";
import version from "../ver.json";
import { useProfileModal } from "../contexts/profileModalContext";

export default function Menu() {
    const websocket = useContext(WebSocketContext);
    const user = useContext(UserContext);
    const { readonly } = useReadonly();
    const { openTariffsFromMenu } = useTariffsModal();
    const { openProfile } = useProfileModal();
    const [propsDialog, setPropsDialog] = useState(false);
    const [showInstruction, setShowInstruction] = useState(false);
    const toggleProps = () => setPropsDialog(false);

    if (!websocket)
        return

    return (
        <div style={{ zIndex: 1040 }}>
            <Navbar bg="body" className="mb-3">
                <div className="d-flex align-items-center w-100">
                    {/* Левая часть: Лого, статус соединения, версия */}
                    <div className="d-flex align-items-center">
                        <Navbar.Brand as={NavLink} to="/" style={{ marginRight: '12px', textDecoration: 'none' }}>
                            <img src="/logo_stage.png" width={40} height={40} alt="Артефакты" />
                        </Navbar.Brand>
                        <div className="d-flex flex-column">
                            {/* Readonly (приоритет) */}
                            {readonly && (
                                <Badge bg="secondary" style={{ cursor: "pointer" }} onClick={openTariffsFromMenu}>
                                    <Icon icon={lockIcon} /> Только чтение
                                </Badge>
                            )}
                            {/* Офлайн (приоритет) */}
                            {!readonly && !websocket.connected && (
                                <Badge bg="secondary" style={{ cursor: "pointer" }} onClick={websocket.reconnect}>
                                    <Icon icon={cloudOfflineOutline} /> Оффлайн
                                </Badge>
                            )}
                            {/* Синхронизация */}
                            {!readonly && websocket.connected && (!websocket.syncDone || websocket.syncInProgress) && (
                                <Badge bg="info">
                                    <Icon icon={sync} spin /> Синхронизация
                                </Badge>
                            )}
                            {/* Онлайн */}
                            {!readonly && websocket.connected && websocket.syncDone && !websocket.syncInProgress && (
                                <Badge bg="success">
                                    <Icon icon={cloudOutline} /> Онлайн
                                </Badge>
                            )}
                        </div>
                        <Navbar.Text className="ms-2 text-muted"><small>v{version.ver}</small></Navbar.Text>
                    </div>

                    {/* Центральная часть: Навигация */}
                    <div className="flex-grow-1 d-flex justify-content-center">
                        <Tabs />
                    </div>

                    {/* Правая часть: Профиль */}
                    <div className="d-flex align-items-center">
                        <Navbar.Text>
                            <Button size="sm" variant="outline-secondary" style={{ cursor: "pointer", width: 32, height: 32, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => openProfile()}>
                                <Icon icon={userIcon} style={{ fontSize: 16 }} />
                            </Button>
                        </Navbar.Text>
                    </div>
                </div>
            </Navbar>
            <WheelPropsModal toggle={toggleProps} popup={propsDialog} key={'wheel'} />
            <InstructionModal show={showInstruction} onHide={() => setShowInstruction(false)} />
        </div>
    );
}